const dbList = {
  databases: [
    {
      db: 'azelcbmy_WP1SQ',
      sitename: 'Welcome',
      sizemib: '14.699',
      usercount: 1,
      userlist: [
        {
          db: 'azelcbmy_WP1SQ',
          user: 'azelcbmy_WP1SQ',
        },
      ],
    },
    {
      db: 'azelcbmy_test',
      sitename: '',
      sizemib: '0.004',
      usercount: 0,
      userlist: [],
    },
  ],
};

export default dbList;
